import React, { useState } from 'react';
import { Info } from 'lucide-react';

/**
 * The "why do you recommend this?" marker next to a setting. Every default
 * in the campaign form has a reason behind it (deliverability research, a
 * provider's own limit); this is where that reason is visible instead of
 * living only in the plan doc.
 */
export default function InfoHint({ text }) {
  const [open, setOpen] = useState(false);

  return (
    <span className="info-hint">
      <button
        type="button"
        className="info-hint-button"
        aria-label={text}
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <Info size={13} />
      </button>
      {open && <span className="info-hint-bubble">{text}</span>}
    </span>
  );
}
